import React, { useMemo } from "react";
import { MobileSidenav } from "./MobileSidenav";
import SkyToggle from "../ui/sky-toggle";
// import { RemainingQuotesPill } from "@/components/billing/RemainingQuotesPill"; // BILLING DISABLED
import { QuotaSummary } from "@/hooks/useBilling";

type AppHeaderProps = {
    sidebarNavIncludeIds?: string[];
    sidebarNavRemoveIds?: string[];
    showOrgSwitcher?: boolean;
    quota?: QuotaSummary;
    quotaLoading?: boolean;
    planName?: string | null;
    planStatus?: string | null;
};

export const AppHeader = React.memo(function AppHeader({
    sidebarNavIncludeIds,
    sidebarNavRemoveIds,
    showOrgSwitcher,
    quota,
    quotaLoading,
    planName,
    planStatus,
}: AppHeaderProps) {

    const normalizedStatus = useMemo(() => planStatus?.replace(/_/g, ' ') ?? null, [planStatus]);

    return (
        <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-border bg-background px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <MobileSidenav
                showOrgSwitcher={showOrgSwitcher}
                sidebarNavIncludeIds={sidebarNavIncludeIds}
                sidebarNavRemoveIds={sidebarNavRemoveIds}
            />
            
            <div className="flex flex-1 items-center justify-end gap-3">
                {planName && (
                    <span className="inline-flex items-center gap-1 rounded-full border border-border/70 bg-muted/70 px-3 py-1 text-xs font-medium text-muted-foreground">
                        <span className="text-foreground">{planName}</span>
                        {normalizedStatus && (
                            <span className="flex items-center gap-1 text-xs capitalize opacity-80">
                                <span aria-hidden className="opacity-40">•</span>
                                <span>{normalizedStatus}</span>
                            </span>
                        )}
                    </span>
                )}
                {/* <RemainingQuotesPill quota={quota} loading={quotaLoading} /> */}
                <SkyToggle />
            </div>
        </div>
    );
});
